(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('CrmReferralSourceDeleteController',CrmReferralSourceDeleteController);

    CrmReferralSourceDeleteController.$inject = ['$uibModalInstance', 'entity', 'CrmReferralSource'];

    function CrmReferralSourceDeleteController($uibModalInstance, entity, CrmReferralSource) {
        var vm = this;

        vm.crmReferralSource = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            CrmReferralSource.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
